<!-- .block-sections-carousel -->
<div
    class="block block-products-carousel"
    [ngClass]="{
        'block-products-carousel--has-items': !!columns?.length
    }"
    [attr.data-layout]="'grid-'"
>
    <div  >
        <!-- <app-block-header [arrows]="true" (next)="carousel.next()" (prev)="carousel.prev()"></app-block-header> -->

        <div class="block-products-carousel__slider">
            <div class="block-products-carousel__preloader"></div>

            <owl-carousel-o [options]="carouselOptions" appOwlPreventClick #carousel>
                <ng-template  *ngFor="let sectionDetails of sections.sectionDetails;let i=index" carouselSlide>
                         <div class="section-item-slider">
                            <app-section-card [section]="sectionDetails" [searchParams]="sections.searchParams[i]"></app-section-card>
                        </div>
                 </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>
<!-- .block-sections-carousel / end -->

